import Vue from "vue";
import Vuex from "vuex";
import basic from "./basic";
import configInfo from "./configInfo";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    basic,
    configInfo,
  },
});
